export default function({ route, store, redirect }) {
  if (route.path.startsWith('/suporte/')) return
  if (!store.getters['auth/isAuthenticated']) {
    redirect('/login')
    return
  }
}
